import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { AppServiceService } from 'src/app/api/app-service.service';
import { StorageService } from '../../core/storage.service';

@Component({
  selector: 'app-profile-update',
  templateUrl: './profile-update.page.html',
  styleUrls: ['./profile-update.page.scss'],
})
export class ProfileUpdatePage implements OnInit {

  public passwordChange = false;
  public profile_details = {
    customer_id: '',
    first_name: '',
    last_name: '',
    email: '',
    mobile_number: '',
    newsalert: 'false',
    points: [],
  }
  public passwordDetails = {
    customer_id: '',
    password: '',
    confirm_password: ''
  }
  public newsalert: boolean = false;

  public isPasswordChangable: boolean = false;
  logOutInProgress: boolean = false;

  public isExpanDiv:boolean = false;
  public selectedResturentIndex:Number = null;
  public isDeleteAccount: boolean = false;
  public otp: any;
  public msgOtp: any = {
    "msg" : "",
    "type" : "",
  };

  registerForm = new FormGroup({
    firstName: new FormControl(this.profile_details.first_name, {
      validators: [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(30),
      ],
      updateOn: 'change'
    }),
    lastName: new FormControl(this.profile_details.last_name, {
      validators: [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(30),
      ],
      updateOn: 'change'
    }),
    telephone: new FormControl(this.profile_details.mobile_number, {
      validators: [
        Validators.required,
        Validators.minLength(10),
        Validators.maxLength(30),
        Validators.pattern(/(\(?([\d \-\)\–\+\/\(]+)\)?([ .\-–\/]?)([\d]+))/)
      ],
      updateOn: 'change'
    }),
    email: new FormControl(this.profile_details.email, {
      validators: [
        Validators.required,
        Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,6}$"),
        // Validators.pattern("^([\\w\\.\\-]+)@([\\w\\-]+)((\\.(\\w){2,3})+)$"),
      ],
      updateOn: 'change'
    }),
  });

  passwordForm = new FormGroup({
    password: new FormControl(this.passwordDetails.password, {
      validators: [
        Validators.maxLength(30),
        // Validators.pattern("^(?=.*[A-Za-z])(?=.*\\d)[A-Za-z\\d]{8,}$")

      ],
      updateOn: 'change'
    }),
    confirm_password: new FormControl(this.passwordDetails.confirm_password, {
      validators: [
        Validators.maxLength(30),
        // Validators.pattern("^(?=.*[A-Za-z])(?=.*\\d)[A-Za-z\\d]{8,}$")

      ],
      updateOn: 'change'
    }),
  });

  isUpdateInProgress: boolean = false;

  emailAddressBackup : string  = '';
  registrationType: string = '';

  public activePointsObject:any = null;

  constructor(public appService: AppServiceService, public storage: StorageService,) {

  }

  ngOnInit() {
  }

  // ionViewWillEnter() {
  //   this.getCustomer();
  // }

  ngAfterViewInit() {
    this.getCustomer();
  }

  getCustomer() {
    setTimeout(() => {
      this.appService.appObject.isLoading = true;
    }, 10);

    this.profile_details.customer_id = this.appService.appObject.userId;
    this.passwordDetails.customer_id = this.appService.appObject.userId;
    this.getUserDetails();
  }

  getUserDetails() {

    this.appService.getUserDetails(this.profile_details).then(data => {
      if (data.status) {
        this.profile_details.customer_id = data.data.id;
        this.profile_details.first_name = data.data.first_name;
        this.profile_details.last_name = data.data.last_name;
        this.profile_details.email = data.data.email;
        this.profile_details.mobile_number = data.data.mobile_number;
        this.newsalert = data.data.is_newsalert;
        this.registrationType = data.data.type;
        this.isPasswordChangable = this.registrationType === 'google' || this.registrationType === 'facebook' || this.registrationType === 'apple' ? false : true;
        this.emailAddressBackup = this.registrationType === 'google' || this.registrationType === 'facebook' || this.registrationType === 'apple' ? data.data.email : '';
        let pointsData = data.data.points ? JSON.parse(data.data.points) : {};
        if (Object.keys(pointsData).length > 0) {
          Object.keys(pointsData).forEach(key => {
            pointsData[key].id = parseInt(key);
          });
          this.profile_details.points = Object.values(pointsData);
          if (this.appService.appObject.selectedRestaurantId != null) {
            this.selectedResturentIndex = this.profile_details.points.findIndex((data) => (data.id ===  this.appService.appObject.selectedRestaurantId));
            if (this.selectedResturentIndex != -1) this.moveItem(this.selectedResturentIndex,0);
          }
        }

        this.activePointsObject = this.profile_details.points && this.profile_details.points[0] ? this.profile_details.points[0] : null;

      }
      this.appService.appObject.isLoading = false;

    }, error => {
      this.appService.appObject.isLoading = false;
    });
  }

  public passwordMatchValidator(g: FormGroup) {
    return g.get('password').value === g.get('passwordConfirm').value
      ? null : { 'mismatch': true };
  }

  public isValidForm(form, input) {
    return (form.get(input).invalid && (form.get(input).dirty || form.get(input).touched));
  }

  async update() {
    console.log(this.registerForm);
    this.registerForm.markAsTouched();
    this.registerForm.controls['firstName'].markAsTouched();
    this.registerForm.controls['lastName'].markAsTouched();
    this.registerForm.controls['telephone'].markAsTouched();
    this.registerForm.controls['email'].markAsTouched();


    if (this.registerForm.valid) {
      if (this.newsalert === true) {
        this.profile_details.newsalert = "true";
      } else {
        this.profile_details.newsalert = "false";
      }
      // replace email address to avoid if user change disabled email input 
      if(this.registrationType === 'google' || this.registrationType === 'facebook' || this.registrationType === 'apple') this.profile_details.email = this.emailAddressBackup;

      this.isUpdateInProgress = true;
      this.appService.updateProfile(this.profile_details).then(data => {
        if (data.status) {
          if (data.msg) this.appService.showToast(data.msg);
          this.getUserDetails();
        }
        this.isUpdateInProgress = false;
      }, error => {
        this.appService.appObject.isLoading = false;
        this.isUpdateInProgress = false;
      });
    }
  }

  async updatePassword() {

    // console.log(this.passwordForm);
    this.passwordForm.markAsTouched();
    this.passwordForm.controls['confirm_password'].markAsTouched();
    this.passwordForm.controls['password'].markAsTouched();

    if (this.registerForm.valid) {
      if (this.passwordChange) {
        this.appService.updatePassword(this.passwordDetails).then(data => {
          if (data.status) {
            this.getUserDetails();
          } else {
            this.appService.appObject.errors = this.appService.getErrorArray(data.msg);
          }
        });
      }
    }

  }

  emailvalidation() {
    if (this.registerForm.value.email) {
      this.registerForm.get('email').setValue(this.registerForm.value.email.trim());
    }
  }

  logout() {
    this.logOutInProgress = true;
    this.appService.logOut().then((resp) => this.logOutInProgress = false).catch((error) => this.logOutInProgress = false);
  }

  expanDiv(){
    this.isExpanDiv = !this.isExpanDiv;
  }

  moveItem(from, to) {
    var f = this.profile_details.points.splice(from, 1)[0];
    this.profile_details.points.splice(to, 0, f);
  }

  changePointObject(point){
    if(point){
      this.activePointsObject = point;
      // this.isExpanDiv = this.isExpanDiv ? false : this.isExpanDiv;
    }
  }

  account_delete_send(){
    this.msgOtp = {
      "msg" : "",
      "type" : "",
    };
    this.appService.appObject.isLoading = true;
    this.appService.sendAccountDeleteEmail({"customer_id" : this.profile_details.customer_id}).then(data => {
      if(data.status) {
        this.isDeleteAccount = true;
        this.msgOtp.type = "s";
        this.msgOtp.msg = data.msg;
      }else{
        this.msgOtp.type = "e";
        this.msgOtp.msg = data.msg;
      }
      this.appService.appObject.isLoading = false;

    }, error => {
      this.appService.appObject.isLoading = false;
    });
  }

  account_delete(){
    this.msgOtp = {
      "msg" : "",
      "type" : "",
    };
    this.appService.appObject.isLoading = true;
    this.appService.sendAccountDelete({"customer_id" : this.profile_details.customer_id,"otp" : this.otp}).then(data => {
      if(data.status) {
        this.isDeleteAccount = false;
        this.msgOtp.type = "s";
        this.msgOtp.msg = data.msg;
        this.logout();
        if(this.appService.isWebVersion){
          this.appService.modalDismiss();
        }
      }else{
        this.msgOtp.type = "e";
        this.msgOtp.msg = data.msg;
      }
      this.otp = "";
      this.appService.appObject.isLoading = false;
    }, error => {
      this.isDeleteAccount = false;
      this.appService.appObject.isLoading = false;
    });
  }

}